// extracted by mini-css-extract-plugin
module.exports = {"root":"FieldCheckboxGroup_root__2uzkM","list":"FieldCheckboxGroup_list__Kr-ZK","twoColumns":"FieldCheckboxGroup_twoColumns__SQcLb","item":"FieldCheckboxGroup_item__OywIl"};